/**
 * Feedback do beta — cliente. Da CONTA (`/me/feedback`); a viagem ativa vai
 * junto só como contexto. O aparelho é lido aqui, uma vez, sem dado da
 * viagem. Sem rede, o rascunho fica no aparelho e a tela avisa.
 */
import type { PutAssinado } from '../memorias/api';

export type TipoDeFeedback = 'bug' | 'ux' | 'melhoria' | 'ideia';
export type GravidadeDeFeedback = 'trava' | 'atrapalha' | 'pequeno';

export const TIPOS: { valor: TipoDeFeedback; rotulo: string }[] = [
  { valor: 'bug', rotulo: 'Bug' },
  { valor: 'ux', rotulo: 'UX' },
  { valor: 'melhoria', rotulo: 'Melhoria' },
  { valor: 'ideia', rotulo: 'Ideia' },
];
export const GRAVIDADES: { valor: GravidadeDeFeedback; rotulo: string; dica: string }[] = [
  { valor: 'trava', rotulo: 'Trava', dica: 'Não dá para seguir' },
  { valor: 'atrapalha', rotulo: 'Atrapalha', dica: 'Dá para contornar' },
  { valor: 'pequeno', rotulo: 'Pequeno', dica: 'Detalhe' },
];

export interface Aparelho {
  userAgent: string;
  viewport: { width: number; height: number };
  standalone: boolean;
  theme: string;
  online: boolean;
  appVersion: string;
  language: string;
}

export function lerAparelho(tema: string): Aparelho {
  const standalone = typeof matchMedia === 'function' && (matchMedia('(display-mode: standalone)').matches || (navigator as { standalone?: boolean }).standalone === true);
  return {
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight },
    standalone,
    theme: tema,
    online: navigator.onLine,
    appVersion: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev',
    language: navigator.language,
  };
}

export interface RascunhoDeFeedback {
  type: TipoDeFeedback;
  severity: GravidadeDeFeedback;
  screen: string;
  description: string;
}

const CHAVE_RASCUNHO = 'nv.feedback-rascunho';

export function lerRascunho(): RascunhoDeFeedback | null {
  try {
    const v = localStorage.getItem(CHAVE_RASCUNHO);
    return v ? (JSON.parse(v) as RascunhoDeFeedback) : null;
  } catch {
    return null;
  }
}
export function guardarRascunho(r: RascunhoDeFeedback | null): void {
  try {
    if (r) localStorage.setItem(CHAVE_RASCUNHO, JSON.stringify(r));
    else localStorage.removeItem(CHAVE_RASCUNHO);
  } catch {
    /* sem armazenamento */
  }
}

async function pedir<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'same-origin', ...init, headers: { ...(init?.body ? { 'content-type': 'application/json' } : {}), ...(init?.headers ?? {}) } });
  if (!res.ok) {
    const corpo = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(corpo.message ?? `Falha (${res.status})`);
  }
  return (await res.json()) as T;
}

export const feedbackApi = {
  enviar: (input: RascunhoDeFeedback & { tripId: string | null; device: Aparelho; screenshot: { mimeType: string; bytes: number } | null; diagnosticCode?: string | null }) =>
    pedir<{ id: string; issueUrl: string | null; upload: PutAssinado | null }>('/api/v1/me/feedback', { method: 'POST', body: JSON.stringify(input) }),
  printPronto: (id: string) => pedir<{ ok: true }>(`/api/v1/me/feedback/${id}/screenshot-complete`, { method: 'POST', body: '{}' }),
};
